import React, { useEffect } from 'react'
import { HomePageWrapper } from './HomePageStyled'
import { VIEW_MODE } from '../../constant'
import { HomePageContent } from '../../components/HomePageContent'
import LandingHeader from '../../components/LandingHeader'
import LandingFooterBig from '../../components/LandingFooterBig'
import LandingBody from '../../components/LandingBody'
import { useRecoilValue } from 'recoil'
import { pageConfigRealState, pageStatusState } from '../../recoil/landingPageState'
import Maintain from '../../components/Maintain/Maintain'
import landingPageStore from '../../stores/landingPageStore'

const HomePage = props => {
  const pageConfigReal = useRecoilValue(pageConfigRealState)
  const pageStatus = useRecoilValue(pageStatusState)

  return (
    pageConfigReal &&
    <>
      {
        pageStatus.status === 'ON' ?
          <>
            <LandingHeader mode={VIEW_MODE.PUBLIC} data={pageConfigReal} />
            <LandingBody>
              <HomePageWrapper>
                <HomePageContent mode={VIEW_MODE.PUBLIC} data={pageConfigReal} />
              </HomePageWrapper>
            </LandingBody>
            <LandingFooterBig data={pageConfigReal} mode={VIEW_MODE.PUBLIC} />
          </>
          : pageStatus.status === 'OFF'
            ? <Maintain />
            : <></>
      }


    </>
  )
}

HomePage.propTypes = {}

export default HomePage
